import { ICart, ICartProductDetail } from "../../../types/cart";
import {
  computeCartSubTotal,
  computeCartTotal,
} from "../../services/optimistic-response.service";

export interface IOptimisticResponse {
  __typename: "Mutation";
  cartProductUpdate: {
    __typename: "Cart";
  } & ICart;
}

export const getOptimisticResponse = (
  cart: ICart | null | undefined,
  productId: string,
  quantity: number
): IOptimisticResponse | {} => {
  let optimisticResponse = {};
  if (cart) {
    const newCart = {
      ...cart,
      items: cart.items.map((el: ICartProductDetail) => ({ ...el })),
    };
    const product = newCart.items.find(
      (item: ICartProductDetail) => item.product.id === productId
    );
    if (product) {
      product.quantity = quantity;
    }

    newCart.items = newCart.items.filter(
      (item: ICartProductDetail) => item.quantity > 0
    );

    const newSubTotal = computeCartSubTotal(newCart.items);
    const newTotal = computeCartTotal(
      newSubTotal,
      newCart.coupon,
      newCart.giftCards
    );

    optimisticResponse = {
      __typename: "Mutation",
      cartProductUpdate: {
        __typename: "Cart",
        ...newCart,
        subTotal: newSubTotal,
        total: newTotal,
      },
    };
  }

  return optimisticResponse;
};
